import { render, staticRenderFns } from "./SchemeRouteSection.vue?vue&type=template&id=1fc4ca23&scoped=true&"
import script from "./SchemeRouteSection.vue?vue&type=script&lang=js&"
export * from "./SchemeRouteSection.vue?vue&type=script&lang=js&"
import style0 from "./SchemeRouteSection.vue?vue&type=style&index=0&id=1fc4ca23&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc4ca23",
  null
  
)

export default component.exports